import { CircleLegend } from "../../../../../../../../assets/icons/CircleLegend";
import {
  Container,
  LegendIconWrapper,
  StyledLegend,
} from "./CustomPromsScatterLegend.styles";

type CustomPromsScatterLegend = {
  valueColorMap: Record<string, string>;
};

export function CustomPromsScatterLegend({
  valueColorMap,
}: CustomPromsScatterLegend) {
  const legend: any[] = [];

  Object.entries(valueColorMap).forEach(([label, color]) => {
    legend.push(
      <StyledLegend key={label}>
        <LegendIconWrapper>
          <CircleLegend fill={color} lineOpacity={0} />
        </LegendIconWrapper>
        <span>{label}</span>
      </StyledLegend>
    );
  });

  return <Container>{legend}</Container>;
}
